import { render, staticRenderFns } from "./RequestFundsTableMobile.vue?vue&type=template&id=5d706130&scoped=true"
import script from "./RequestFundsTableMobile.vue?vue&type=script&lang=js"
export * from "./RequestFundsTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d706130",
  null
  
)

export default component.exports